/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Nav_Support_DescInputs */

const en_mk_nav_support_desc = /** @type {(inputs: Mk_Nav_Support_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find help for your next step.`)
};

const id_mk_nav_support_desc = /** @type {(inputs: Mk_Nav_Support_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temukan bantuan untuk langkah berikutnya.`)
};

/**
* | output |
* | --- |
* | "Find help for your next step." |
*
* @param {Mk_Nav_Support_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_nav_support_desc = /** @type {((inputs?: Mk_Nav_Support_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Nav_Support_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_nav_support_desc(inputs)
	return en_mk_nav_support_desc(inputs)
});